import { IApplicationState } from '../../types/redux';

export function selectIsInfrastructureFetched(state: IApplicationState) {
  return state.infrastructure.isFetched || false;
}
